//#region INTERFACE IApplicationText

export interface IApplicationText<T = string> {
  features: {
    orderSettings: {
      bodyPlaceholder: T; //This is replaced on component level
      ccRecipientPlaceholder: T;
      contactNamePlaceholder: T;
      contactNumberPlaceholder: T; //This needs to use the new directive once completed
      orderNumberPlaceholder: T;
      pdfClausePlaceholder: T;
      subjectPlaceholder: T; //This is replaced on component level
    }
  },
  settings: {
    preferenceSettings: {
      dateFormat: T;
    }
    userTableSetting: {
      enterSelection: T;
      tabSelection: T;
    }
  };
}

//#endregion

//#region CONST DEFAULT_APPLICATION_TEXT
export const DEFAULT_APPLICATION_TEXT: Readonly<IApplicationText> = {
  features: {
    orderSettings: {
      bodyPlaceholder: 'Please see attached order as per subject line.',
      ccRecipientPlaceholder: 'email@domain.com',
      contactNamePlaceholder: 'Ptero Doe',
      contactNumberPlaceholder: '+27 000 0000',
      orderNumberPlaceholder: 'AUTO',
      pdfClausePlaceholder: 'Delivery notes that will appear at the bottom of the purchase order PDF.',
      subjectPlaceholder: `{Store Name} {Order #} {Account #}`,
    },
  },
  settings: {
    preferenceSettings: {
      dateFormat: 'Date Format',
    },
    userTableSetting: {
      enterSelection: 'When the cursor is on the last cell of a column and enter is pressed',
      tabSelection: 'When the cursor is on the last cell of a page and tab is pressed',
    },
  },
};
//#endregion
